import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitter,
  faTelegram,
  faMedium,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import Foot from "./Foot";
import { motion } from "framer-motion";

const Footer = () => {
  return (
    <div>
      <div className="footer">
        <div className="content-wrapper align-center">
          <motion.a
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ ease: "easeOut", duration: 1 }}
            href="#"
            aria-current="page"
            className="logo w-inline-block w--current"
          >
            <img
              src="images/cloudaxcolorwhite.svg"
              loading="lazy"
              alt="growkit template logo"
              className="logo"
            />
          </motion.a>
          <motion.p
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ ease: "easeOut", duration: 1 }}
            className="chainsupp"
          >
            Multiple Chain Support
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ ease: "easeOut", duration: 1 }}
            className="flex justify-center item-center my-1 text-center"
          >
            <img
              className="w-[25px] mr-6 rounded-full p-[3px] bg-white"
              src="images/bsc.png"
              alt="coin"
            />
            <img
              className="w-[25px] mr-6 rounded-full p-[3px] bg-white"
              src="images/eth.webp"
              alt="coin"
            />
            <img
              className="w-[25px] mr-6 rounded-full p-[3px] bg-white"
              src="images/matic.png"
              alt="coin"
            />
            <img
              className="w-[25px] rounded-full p-[3px] bg-white"
              src="images/sol.png"
              alt="coin"
            />
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ ease: "easeOut", duration: 1 }} className="flex justify-center gap1 items-center mt-5">
            <p className="mt-1 audited">Audited by </p>
            <img
              className="w-[8rem]"
              src="images/cert-white2.png"
              alt="icon"
            />
          </motion.div>

          <div className="foooter wf-section">
            <div className="content-wrapper">
              <div className="_4-column-grid">
                <motion.div
                  initial={{ opacity: 0, y: 60 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ ease: "easeOut", duration: 1 }}
                  className="icon-block"
                >
                  <div className="icon-block-text-wrapper">
                    <h3 className="text-style-all-caps">Community</h3>
                    <div className="text-small opacity-90">
                      <div className="social-icons footercopyright">
                        <a
                          href="https://t.me/cloudaxofficial"
                          className="hover:text-[#2F79F9]"
                        >
                          <FontAwesomeIcon
                            className="text-xl mr-4 footersocialicons"
                            icon={faTelegram}
                          />
                        </a>
                        <a
                          href="http://cloudax.medium.com/"
                          className="hover:text-[#2F79F9]"
                        >
                          <FontAwesomeIcon
                            className="text-xl mr-4 footersocialicons"
                            icon={faMedium}
                          />
                        </a>
                        <a href="/" className="hover:text-[#2F79F9]">
                          <FontAwesomeIcon
                            className="text-xl mr-4 footersocialicons"
                            icon={faGithub}
                          />{" "}
                        </a>
                        <a
                          className="hover:text-[#2F79F9]"
                          target="blank"
                          href="https://twitter.com/cloudaxofficial"
                        >
                          <FontAwesomeIcon
                            className="text-xl mr-4 footersocialicons"
                            icon={faTwitter}
                          />
                        </a>
                      </div>
                      {/* <div className="text-tiny footercopyright">
                      All rights reserved
                      <a href="#" target="_blank">
                        <span className="link">
                          <strong> Cloudax</strong>
                        </span>
                      </a>
                    </div> */}
                    </div>
                  </div>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 60 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ ease: "easeOut", duration: 1 }}
                  className="icon-block"
                >
                  <div className="icon-block-text-wrapper">
                    <h3 className="text-style-all-caps">Ecosystem</h3>
                    <div className="text-small opacity-90 footercopyright">
                      <ul>
                        <li>
                          <a
                            className="footerlink"
                            href="https://launchpad.cloudax.io/"
                            target="_blank"
                          >
                            Join Presale
                          </a>
                        </li>
                        <li>
                          <a
                            className="footerlink"
                            href="http://swap.cloudax.io/swap"
                            target="_blank"
                          >
                            DEX
                          </a>
                        </li>
                        <li>
                          <a
                            className="footerlink"
                            href="http://docs.cloudax.io/"
                            target="_blank"
                          >
                            Whitepaper
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 60 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ ease: "easeOut", duration: 1 }}
                  className="icon-block"
                >
                  <div className="icon-block-text-wrapper">
                    <h3 className="text-style-all-caps">Discover</h3>
                    <div className="text-small opacity-90 footercopyright">
                      <ul>
                        <li>
                          <a
                            className="footerlink"
                            href="http://cloudax.medium.com/"
                            target="_blank"
                          >
                            Medium
                          </a>
                        </li>
                        <li>
                          <a
                            className="footerlink"
                            href="http://cloudax.medium.com/"
                            target="_blank"
                          >
                            Getting Started
                          </a>
                        </li>
                        <li>
                          <a className="footerlink" href="#">
                            BscScan <small className="soon">soon</small>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 60 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ ease: "easeOut", duration: 1 }}
                  className="icon-block"
                >
                  <div className="icon-block-text-wrapper">
                    <h3 className="text-style-all-caps">Explore</h3>
                    <div className="text-small opacity-90 footercopyright">
                      <ul>
                        <li>
                          <a className="footerlink" href="#">
                            Academy<small className="soon">soon</small>
                          </a>
                        </li>
                        <li>
                          <a className="footerlink" href="faq" target="_blank">
                            FAQ
                          </a>
                        </li>
                        <li>
                          <a
                            className="footerlink"
                            href="https://www.cloudax.io/disclaimer"
                            target="_blank"
                          >
                            Disclaimer
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
          <Foot />
        </div>
      </div>
    </div>
  );
};

export default Footer;
